<template>
    <v-container class="ma-0 pa-0 pb-8">

        <div class="pt-6 px-8 pb-6">
            <v-row class="ma-0 mb-2">
                <strong>Filtros</strong>
                <v-spacer></v-spacer>
                <v-btn @click="removeFilter()" small class="elevation-0" style="border:solid 1px #dddddd;">
                    <v-icon small class="mr-1">mdi-filter-off</v-icon>Limpiar
                </v-btn>
                <v-btn class="hidden-md-and-up elevation-0 ml-4" @click="closeFilter()" small>
                    <v-icon class="mr-1">mdi-close</v-icon>
                </v-btn>
            </v-row>

            <v-text-field v-model="filters.pos" label="Producto" clearable @keydown.enter="filter()"></v-text-field>

            <v-autocomplete class="dense-select" clearable @keydown.enter="filter()" v-model="filters.category_id" :items="categoriesLists" item-text="name" item-value="id" attach chips label="Categoría(s)" multiple>
                <template slot="no-data" class="pa-2">No existen movimientos relacionados.</template>  
            </v-autocomplete>

        </div>
        <v-card style="position:absolute; bottom:0; width:100%;" tile color="primary">
            <v-list-item link @click="filter()" dark>
                <v-list-item-content>
                    <strong>Filtrar (0)</strong>
                </v-list-item-content>
            </v-list-item>    
        </v-card>
    </v-container>
</template>
<script>
  export default {
    data: () => ({
        menuTo:false,
        menuFrom:false,
        filters:{
            pos:undefined,
            category_id:undefined
        },
    }),
    computed: {
        categoriesLists(){
            return this.$store.state.category.categories;
        }
    },
    methods: {
        filter(){
            this.$store.dispatch('inventory_cost/updateFilters', this.filters)
        },
        removeFilter(){
            this.filters = {
                pos:undefined,
                category_id:undefined
            }
            this.$store.dispatch('inventory_cost/cleanFilter')
        },
        closeFilter(){
            this.$emit("closeFilter", false);
        },
    }
  }
</script>
<style>
.dense-select .v-list-item__action{
    display: none!important;
}
.dense-select .v-list-item {
    padding: 0 10px!important;
    min-height: 0px;
}
.dense-select .v-list-item__title{
    font-size:12px!important;
}
.dense-select .v-list-item__content {
    padding: 10px 0!important;
}
</style>